import React, {
    memo, useEffect, useState, useContext
} from 'react'
import { Link } from 'react-router-dom'
import { FiUser, FiHome, FiSmartphone, FiRepeat, FiUsers, FiFileText, FiCreditCard, FiCalendar, FiAlertTriangle } from 'react-icons/fi'
import Tour from 'reactour'
import { FiMenu } from 'react-icons/fi'
import { useQuery } from '@tanstack/react-query'
import { useMediaQuery } from 'react-responsive'

import { Container, Menu } from './styles'
import { GlobalContext } from '../../contexts/GlobalContext'
import { Button } from '../Form'
import { api, authHeaders } from '../../services/api'
import logo from '../../assets/images/positronic horizontal.png'

const NavOptions = memo(() => {
    const { user, handleInstalarApp, showButtonInstacaoApp } = useContext(GlobalContext)

    const isDesktop = useMediaQuery({ query: '(min-width: 1024px)' })

    const [fullHeightMenu, setFullHeightMenu] = useState(false)
    const [showMenu, setShowMenu] = useState(false)
    const [showTour, setShowTour] = useState(false)

    const { data: temFamilia } = useQuery({
        queryKey: ['obter-membros-familia'],
        queryFn: async () => {
            const response = await api.get('assinatura/grupo', {
                params: {
                    apenas_ativos: true
                },
                ...authHeaders()
            })

            return !!(response.titular.length || response.membro.length)
        }
    })

    function toggleShowMenu() {
        try {
            const novoStatus = !showMenu

            if (novoStatus && window.innerWidth <= 600) {
                window.scrollTo(0, 0)
            }

            setShowMenu(novoStatus)
        } catch (e) { }
    }

    useEffect(() => {
        const handleScroll = () => {
            setFullHeightMenu(window.scrollY >= 65)
        }

        document.addEventListener('scroll', handleScroll)

        return () => {
            document.removeEventListener('scroll', handleScroll)
        }
    }, [])

    useEffect(() => {
        const wasShownInstalacaoApp = localStorage.getItem('zelai:tour-instalacao-app')

        if (!wasShownInstalacaoApp && window.innerWidth > 600) {
            setShowTour(true)
        }
    }, [])

    const identificadoresPlanosQueSuportamMembros = ['familia', 'familia_anual', 'empresa', 'empresa_anual']

    const assinaturasAtivasTitular = user.pessoa.assinaturas.filter(a => a.status === 'authorized').map(a => a.plano.identificador)
    const permiteGerenciarFamilia = identificadoresPlanosQueSuportamMembros.some(i => new Set(assinaturasAtivasTitular).has(i))
    const eAdmin = user?.perfil.id === 1

    return (
        <>
            <Container className="text-slate-800 flex items-center print:hidden">
                <div
                    className="text-slate-800 menu-trigger p-2 cursor-pointer hover:opacity-80"
                    style={{ position: 'absolute', top: 14, left: 6 }}
                    onClick={toggleShowMenu}
                >
                    <FiMenu size={26} color="#1e293b" />
                </div>

                <Menu
                    fullHeight={fullHeightMenu}
                    visivel={isDesktop ? true : showMenu}
                    onMouseEnter={isDesktop ? null : toggleShowMenu}
                    onMouseLeave={isDesktop ? null : toggleShowMenu}
                    className="bg-slate-100"
                >
                    <div className="m-5 sm:hidden">
                        <img src={logo} alt="Home" className="object-contain h-11" />
                    </div>

                    <Link
                        to={eAdmin ? '/admin' : '/dashboard'}
                        onClick={toggleShowMenu}
                        className="text-slate-700 hover:opacity-80 border-b border-b-slate-200 h-14"
                    >
                        <FiHome size={20} />
                        <span>Home</span>
                    </Link>

                    {!eAdmin ? (
                        <>
                            <Link
                                to="/dados_cadastrais"
                                onClick={toggleShowMenu}
                                className="text-slate-700 hover:opacity-80 border-b border-b-slate-200 h-14"
                            >
                                <FiUser size={20} />
                                <span>Dados cadastrais</span>
                            </Link>

                            <Link
                                to="/assinaturas"
                                onClick={toggleShowMenu}
                                className="text-slate-700 hover:opacity-80 border-b border-b-slate-200 h-14"
                            >
                                <FiRepeat size={20} />
                                <span>Minhas assinaturas</span>
                            </Link>

                            {temFamilia || permiteGerenciarFamilia ? (
                                <Link
                                    to="/familia"
                                    onClick={toggleShowMenu}
                                    className="text-slate-700 hover:opacity-80 border-b border-b-slate-200 h-14"
                                >
                                    <FiUsers size={20} />
                                    <span>Grupos de pessoas</span>
                                </Link>
                            ) : null}

                            {/*
                             <Link
                                to="/agenda"
                                onClick={toggleShowMenu}
                                className="text-slate-700 hover:opacity-80 border-b border-b-slate-200 h-14"
                            >
                                <FiCalendar size={20} />
                                <span>Agenda</span>
                            </Link>

                            <Link
                                to="/formas-pagamento"
                                onClick={toggleShowMenu}
                                className="text-slate-700 hover:opacity-80 border-b border-b-slate-200 h-14"
                            >
                                <FiCreditCard size={20} />
                                <span>Formas de pagamento</span>
                            </Link> */}

                            {showButtonInstacaoApp && (
                                <Link
                                    to="#"
                                    id="icone-instalacao-app"
                                    onClick={e => {
                                        e.preventDefault()

                                        toggleShowMenu()

                                        handleInstalarApp()
                                    }}
                                    className="text-slate-700 hover:opacity-80 border-b border-b-slate-200 h-14"
                                >
                                    <FiSmartphone size={20} />
                                    <span>Instalar como aplicativo</span>
                                </Link>
                            )}
                        </>
                    ) : ( // Apenas para USUÁRIO ADMIN
                        <>
                            <Link
                                to="/admin/assinaturas"
                                onClick={toggleShowMenu}
                                className="text-slate-700 hover:opacity-80 border-b border-b-slate-200 h-14"
                            >
                                <FiUsers size={20} />
                                <span>Assinaturas</span>
                            </Link>

                            <Link
                                to="/admin/faturas"
                                onClick={toggleShowMenu}
                                className="text-slate-700 hover:opacity-80 border-b border-b-slate-200 h-14"
                            >
                                <FiFileText size={20} />
                                <span>Faturas</span>
                            </Link>

                            <Link
                                to="/admin/acessos"
                                onClick={toggleShowMenu}
                                className="text-slate-700 hover:opacity-80 border-b border-b-slate-200 h-14"
                            >
                                <FiUsers size={20} />
                                <span>Acessos</span>
                            </Link>

                            <Link
                                to="/admin/gratuidades"
                                onClick={toggleShowMenu}
                                className="text-slate-700 hover:opacity-80 border-b border-b-slate-200 h-14"
                            >
                                <FiAlertTriangle size={20} />
                                <span>Gratuidades</span>
                            </Link>
                        </>
                    )}

                    {/* {grupos.length > 0 && grupos.map(grupo => (
                        <Link
                            key={grupo.descricao} to={`/grupo_permissoes/${grupo.id}`}
                            className="navbar-link text-red-700 hover:opacity-80"
                            onClick={toggleShowMenu}
                        >
                            <div>
                                {React.createElement(icons[grupo.icone], { size: 20 })}
                            </div>

                            <span>{grupo.descricao}</span>
                        </Link>
                    ))} */}
                </Menu>
            </Container>

            <Tour
                steps={[
                    {
                        selector: '#icone-instalacao-app',
                        content: ({ close }) => (
                            <div className="container">
                                <p>Aqui você pode instalar o Prontuário Médico, tornando o acesso muito mais fácil.</p>
                                <br />
                                <div className="flex flex-col gap-2">
                                    <Button
                                        onClick={() => {
                                            setShowTour(false)
                                            close()

                                            handleInstalarApp()
                                        }}
                                    >
                                        Instalar agora
                                    </Button>

                                    <Button
                                        className="bg-slate-100 text-slate-800"
                                        onClick={() => {
                                            setShowTour(false)
                                            close()
                                        }}
                                    >
                                        Fechar
                                    </Button>
                                </div>
                            </div>
                        )
                    }
                ]}
                isOpen={showTour}
                onRequestClose={() => {
                    setShowTour(false)

                    localStorage.setItem('zelai:tour-instalacao-app', 'true')
                }}
                rounded={10}
                scrollDuration={200}
                startAt={0}
                showNumber={false}
            />
        </>
    )
})

export default NavOptions
